define(["exports", "react", "./CvContainer", "./CvHeader", "./CvBody", "./CvProvider"], function (_exports, _react, _CvContainer, _CvHeader, _CvBody, _CvProvider) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _CvContainer = _interopRequireDefault(_CvContainer);
  _CvHeader = _interopRequireDefault(_CvHeader);
  _CvBody = _interopRequireDefault(_CvBody);

  var Curriculum = function Curriculum(_ref) {
    var cvData = _ref.cvData,
        avatarUrl = _ref.avatarUrl,
        currentLanguage = _ref.currentLanguage;
    return /*#__PURE__*/_react.default.createElement(_CvProvider.CvProvider, null, /*#__PURE__*/_react.default.createElement(_CvContainer.default, {
      cvData: cvData,
      avatarUrl: avatarUrl
    }, /*#__PURE__*/_react.default.createElement(_CvHeader.default, {
      cvData: cvData,
      avatarUrl: avatarUrl
    }), /*#__PURE__*/_react.default.createElement(_CvBody.default, {
      cvData: cvData,
      currentLanguage: currentLanguage
    })));
  };

  Curriculum.defaultProps = {
    cvData: {},
    avatarUrl: '',
    shouldHideLabels: false
  };
  var _default = Curriculum;
  _exports.default = _default;
});